import request from '@/utils/request'

export function modifyPassword(data) {
  return request({
    url: '/api/user/modifyPassword',
    method: 'post',
    data
  })
} 